import { findNodeId } from "../helpers/findNodeId";

export function handleGoldPriceIsActiveUpdated(state, patch) {
    const {type, payload} = patch

    const nodeId = findNodeId(state, payload.qdId);

    if (!nodeId) {
        return state;
    }

    const q = state.quantitiesById[nodeId];

    if (!q) {
        return state;
    }

    const side =
        payload.priceType === 1
            ? "buy"
            : "sell";

    return {
        ...state,
        quantitiesById: {
            ...state.quantitiesById,
            [nodeId]: {
                ...q,
                active: {
                    ...q.active,
                    [side]: {
                        ...q.active[side],
                        isActive: payload.isActive,
                    },
                },
            },
        },
    };
}